import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Button, Drawer, IconButton, ListItemIcon, ListItemText, MenuItem, MenuList, Typography } from "@mui/material";
import { TVoidCalBack, dcolors, dlog } from "corexxx";
import React, { CSSProperties, ReactNode, useState } from "react";
import { Route } from "react-router-dom";
import _ from "underscore";
import { DrawerNestedNavigationDebugOnly } from "../components/screens/Register";
import { useDAppCommand } from "./DAppCommand";
import { DCol } from "./DCol";
import { DNavigation } from "./DNavigation";
import { DResponsiveWindow } from "./DResponsiveWindow";
import { DRow } from "./DRow";
import { DSpace } from "./DSpace";
import { DText } from "./DText";

import MenuIcon from "@mui/icons-material/Menu";
import { DHook } from "../common_hooks/DHook";
import { DDot } from "./DDot";
import { DFooter } from "./DFooter";
import { DPageInConstruction } from "./DSamplePages";
export type TNavigationItem = {
    text: string;
    onClick?: TVoidCalBack;
    icon?: any;
    subtext?: string;
    href?: string;
    showAfterLogin?: boolean;
};

export type TNestedNavigation = Array<{
    title: string;
    path?: string;
    screen?: JSX.Element;
    screenFn?: () => JSX.Element;
    icon?: JSX.Element;
    child?: { title: string; path?: string; screen?: JSX.Element; screenFn?: () => JSX.Element; icon?: JSX.Element }[];
}>;

// Core App Layout and Navigation
export type TDPageRootLayoutConfig = {
    title: string;
    title_path?: string
    settingNavList?: { text: string; link: string }[];
    login?: boolean;
    drawerWidth?: number;
    logo?: any;
    icon?: any;
    rightActions?: TNavigationItem[]; // showing list of action in right size.
    appBarTrasparent?: boolean;
    appBarTextStyle?: CSSProperties;
    appBarStyle?: CSSProperties;
    hideFooter?: Boolean;
    topNavigation?: TNestedNavigation;
    appBarConfig?: {
        appBarRightJSX?: JSX.Element;
    };
};

export function getAllRoute(nav?: TNestedNavigation): JSX.Element {
    return (
        <>
            {nav?.map((x) => {
                return (
                    <>
                        {x.child?.map((y) => {
                            dlog.d("registering path:" + x.path + y.path);
                            if (y.screen) {
                                return <Route path={"" + x.path + y.path} element={y.screen} />;
                            } else {
                                return <Route path={"" + x.path + y.path} element={y.screenFn?.()} />;
                                //return <Route path={x.path + y.path}></Route>;
                            }
                        })}
                    </>
                );
            })}
        </>
    );
}

  // should not be used externally
  /*export*/ const DAppParentWrapper = ({ children }: { children: any }) => {
    const appCommand = useDAppCommand();
    return (
        <div>
            {appCommand.isDebugMode() ? (
                <DText
                    style={{
                        position: "fixed",
                        top: 0,
                        width: "100%",
                        color: "white",
                        background: dcolors.pallets.red600,
                        zIndex: 10000,
                        fontSize: 10,
                        textAlign: "center",
                    }}
                >
                    You are running in debug mode
                </DText>
            ) : null}
            <div>{children}</div>
        </div>
    );
};

// option 1: Only Top Navigation Any Page from this project must be wrap around this.
export const DPageRootLayout = ({
    children,
    style,
    config,
    leftElement,
    navLeftOffset,
}: {
    children: any;
    style?: CSSProperties;
    config: TDPageRootLayoutConfig;
    leftElement?: any;
    navLeftOffset?: number;
}) => {
    const appCommand = useDAppCommand();
    if (config.login && !appCommand.accountState) {
        return (
            <DAppParentWrapper>
                <DResponsiveWindow>
                    <Alert severity="error" style={{ marginTop: 30, minHeight: "100vh" }}>
                        <AlertTitle>You are not logged in.</AlertTitle>
                        Please fist login and then you should able to view this page. <a href="/account">click</a> to login here.
                    </Alert>
                </DResponsiveWindow>
            </DAppParentWrapper>
        );
    }
    return (
        <DAppParentWrapper>
            <DCol style={{ flex: 1, position: "relative" }}>
                <DNavigation leftElement={leftElement} config={config} leftOffset={navLeftOffset} />
                <DCol style={{ paddingLeft: 10, paddingRight: 10, ...style, paddingTop: 46, minHeight: "100vh" }}>
                    <DCol style={{ position: "relative" }}>{children}</DCol>
                    {!config.hideFooter ? <DFooter /> : null}
                </DCol>
            </DCol>
        </DAppParentWrapper>
    );
};

// Option 2: top and side navigation App Root with Top Navigation Bar + Drawer
export const DPageRootLayoutWithDrawer = React.memo(({
    config,
    children,
    drawerContent,
    drawerOpen,
    drawerPreset,
    bodyStyle
}: {
    config: TDPageRootLayoutConfig;
    bodyStyle?: CSSProperties
    children?: any;
    drawerContent?: any;
    drawerOpen?: boolean;
    drawerPreset?: {
        drawerWidth?: number;
        headerText?: String;
        headerExtra?: JSX.Element;
        footerExtra?: JSX.Element;
        footerText?: String;
        drawerNestedNavigation?: TNestedNavigation;
        onSettingClicked?: TVoidCalBack;
        drawerBackground?: string;
        color?: string;
        menuList?: {
            icon?: ReactNode;
            shortcuts?: ReactNode;
            name: string;
            onClick?: TVoidCalBack;
            screen?: JSX.Element
        }[];
    };
}) => {
    dlog.d("DPageRootLayoutWithDrawer rerendered")
    const appCommand = useDAppCommand()
    const isTablet = false;
    let KdrawerWidth = isTablet ? window.innerWidth : drawerPreset?.drawerWidth || config?.drawerWidth || 350;
    const [open, setOpen] = React.useState(drawerOpen || false);
    const [holderNode, setHolderNode] = useState<JSX.Element | undefined>(drawerPreset?.menuList?.[0]?.screen || children);
    const [drawerWidth, setDrawerWidth] = React.useState(0);
    const [expanded, setExpanded] = React.useState<string | false>(false);
    const [selected, setSelected] = React.useState('')
    const [drawerActiveIndex, setDrawerActiveIndex] = useState(0)

    // Getting rendered too many time
    DHook.useMountLogger("DPageRootLayoutWithDrawer")

    if (appCommand.isDebugMode()) {
        _.extend(drawerPreset?.drawerNestedNavigation, DrawerNestedNavigationDebugOnly);
    }

    DHook.useAsyncEffect(async () => {
        if (!appCommand.state.accountState?.auth_token_) {
            appCommand.api.navigate('/account')
        } else {
            if (await appCommand.api.checkLogin() == false) {
                appCommand.logout();
                appCommand.api.navigate('/account')
            }
        }
    }, [])


    // TODO: THIS IS A Conclict
    // LITHUK needs this as as the child should be changing 
    // TODO: This is causing issue while chnageing anything will effect navigation 
    React.useEffect(() => {
        // This is chnanging the currently renderer menu abductbly
        //setHolderNode(drawerPreset?.menuList?.[0]?.screen || children)
    }, [children, drawerPreset])

    React.useEffect(() => {
        setDrawerWidth(open ? KdrawerWidth : 0);
    }, [open]);
    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    let drawerStyle: CSSProperties = { color: drawerPreset?.color || "black", background: drawerPreset?.drawerBackground || "white" };

    return (
        <DCol style={bodyStyle}>
            <DPageRootLayout
                config={config}
                navLeftOffset={drawerWidth}
                leftElement={
                    <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 1 }} onClick={() => setOpen(!open)}>
                        {<MenuIcon style={{ ...config?.appBarTextStyle }} />}
                    </IconButton>
                }
                style={{
                    marginLeft: open ? drawerWidth : 0,
                    width: open ? `calc( 100% - ${drawerWidth}px)` : "100%",
                }}
            >
                {holderNode || <DPageInConstruction />}
                <Drawer
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: drawerWidth,
                            boxSizing: "border-box",
                        },
                        ...drawerStyle,
                    }}
                    variant="persistent"
                    anchor="left"
                    open={open}
                >
                    {drawerContent}
                    {drawerPreset ? (
                        <DCol style={{ ...drawerStyle }}>
                            <div style={{ backgroundColor: appCommand.state.appConfig?.primary_color || 'black', padding: '15px 5px', textAlign: "left", color: 'white' }}>
                                <DRow center>
                                    <DText mode="title" style={{ textAlign: "left", color: 'white', flex: 1 }}>
                                        {drawerPreset.headerText || 'Welcome'}
                                    </DText>
                                    <IconButton size="large" edge="start" color="inherit" aria-label="menu" onClick={() => setOpen(!open)}>
                                        {<CloseIcon style={{ color: 'white', ...config?.appBarTextStyle }} />}
                                    </IconButton>
                                </DRow>
                                {drawerPreset.headerExtra}
                            </div>
                            <MenuList>
                                {drawerPreset.menuList?.map((x, idx) => {
                                    return (
                                        <MenuItem key={idx + ""} onClick={() => {
                                            x.onClick?.();
                                            setDrawerActiveIndex(idx)
                                            setHolderNode(x.screen);
                                        }}>
                                            <DDot size={10} color={idx == drawerActiveIndex ? dcolors.pallets.blue400 : '#00000000'} style={{ marginRight: 5 }} />
                                            {x.icon ? <ListItemIcon style={{ ...drawerStyle }}>{x.icon}</ListItemIcon> : null}
                                            <ListItemText style={{ ...drawerStyle }}>{x.name}</ListItemText>
                                            <Typography variant="body2" style={{ ...drawerStyle }}>
                                                {x.shortcuts}
                                            </Typography>
                                        </MenuItem>
                                    );
                                })}
                            </MenuList>

                            {drawerPreset?.drawerNestedNavigation
                                ? drawerPreset.drawerNestedNavigation.map((x, idx) => {
                                    if (!x.child) {
                                        return (
                                            <Button
                                                key={idx}
                                                style={{
                                                    color: drawerStyle.color,
                                                    justifyContent: "left",
                                                    textTransform: "capitalize",
                                                    fontSize: 16,
                                                    paddingLeft: 20,
                                                    fontWeight: selected == `${idx}` ? 'bold' : 'normal',
                                                    backgroundColor: selected == `${idx}` ? dcolors.pallets.blue50 : dcolors.pallets.transparent
                                                }}
                                                href={x.path}
                                                onClick={() => {
                                                    setSelected(`${idx}`)
                                                    setHolderNode(x.screen);
                                                }}
                                                startIcon={x.icon}
                                            >
                                                {x.title}
                                            </Button>
                                        );
                                    }

                                    return (
                                        <Accordion
                                            key={idx}
                                            disableGutters={true}
                                            expanded={expanded === x.title}
                                            onChange={handleChange(x.title)}
                                            style={{ background: "#00000000", boxShadow: "none", width: '100%', border: 0 }}
                                        >
                                            <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: drawerStyle.color }} />} style={{ margin: 0, padding: 0, border: 0, flex: 1, width: '100%' }}>
                                                <Button
                                                    key={idx}
                                                    style={{
                                                        color: drawerStyle.color,
                                                        justifyContent: "left",
                                                        textTransform: "capitalize",
                                                        fontSize: 16,
                                                        width: "100%",
                                                        paddingLeft: 20,
                                                        fontWeight: selected == `${idx}` ? 'bold' : 'normal',
                                                        backgroundColor: selected == `${idx}` ? dcolors.pallets.blue50 : dcolors.pallets.transparent
                                                    }}
                                                    href={x.path}
                                                    onClick={() => {
                                                        setSelected(`${idx}`)
                                                        setHolderNode(x.screen);
                                                    }}
                                                    startIcon={x.icon}
                                                >
                                                    <DText>{x.title}</DText>
                                                </Button>

                                            </AccordionSummary>
                                            <AccordionDetails style={{ padding: 0, paddingLeft: 0 }}>
                                                <DCol>
                                                    {x.child?.map((y, idy) => {
                                                        return (
                                                            <Button
                                                                key={idy}
                                                                style={{
                                                                    color: drawerStyle.color,
                                                                    justifyContent: "left",
                                                                    textTransform: "capitalize",
                                                                    marginLeft: 20,
                                                                    fontSize: 16,
                                                                    fontWeight: selected == `${idx}.${idy}` ? 'bold' : 'normal',
                                                                    backgroundColor: selected == `${idx}.${idy}` ? dcolors.pallets.blue50 : dcolors.pallets.transparent
                                                                }}
                                                                startIcon={y.icon}
                                                                href={y.path ? x.path + y.path : undefined}
                                                                onClick={() => {
                                                                    setSelected(`${idx}.${idy}`)
                                                                    setHolderNode(y.screen);
                                                                }}
                                                            >
                                                                {y.title}
                                                            </Button>
                                                        );
                                                    })}
                                                </DCol>
                                            </AccordionDetails>
                                        </Accordion>
                                    );
                                })
                                : null}
                            <DSpace />
                            <DCol style={{ borderTop: "1px solid grey", padding: 20, flex: 0, width: '100%' }}>
                                <DRow style={{ alignItems: "center", flex: 0 }}>
                                    <DText style={{ flex: 1, color: drawerStyle.color }}>© copyright grodok.com 2023</DText>
                                </DRow>
                            </DCol>

                        </DCol>
                    ) : null}
                </Drawer>
            </DPageRootLayout>
        </DCol >
    );
});